import type React from "react";

export const UserOrdersProductSkeleton: React.FC = () => {
  return (
    <div className="p-3 bg-bg-secondary space-y-4 rounded-md w-full animate-pulse">
      <div className="flex flex-row-reverse items-center gap-x-2">
        <div className="size-10.5 rounded-xs border border-stroke-white bg-text-disabled/20" />
        <div className="text-xs text-right space-y-1 flex-1">
          <div className="h-4 bg-text-disabled/20 rounded w-24" />
        </div>
      </div>
      <div className="flex items-center justify-between flex-row-reverse">
        <div className="h-3 bg-text-disabled/20 rounded w-20" />
        <div className="h-5 bg-text-disabled/20 rounded-full w-12" />
      </div>
      <div className="space-y-2">
        <div className="h-3 bg-text-disabled/20 rounded w-full" />
        <div className="h-3 bg-text-disabled/20 rounded w-3/4" />
      </div>
    </div>
  );
};
